import React from 'react'
import { useTranslation } from 'react-i18next'

import { IProps } from './interface/IProps'
import { StyledCell, StyledRow, StyledTableBody } from './style'
export const TableBody = ({ tableData }: IProps) => {
  const { t } = useTranslation()

  return (
    <StyledTableBody>
      {tableData.map((item, index) => (
        <StyledRow key={index}>
          <StyledCell>{item.referee.establishment.name}</StyledCell>
          <StyledCell>{item.referee.person.fullName}</StyledCell>
          <StyledCell>{item.redeemedAt || 'Not yet purchased'}</StyledCell>
        </StyledRow>
      ))}
    </StyledTableBody>
  )
}
